// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.changeitemgroup', {
        url:'/changeitemgroup',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/changeitemgroup/changeitemgroup.tpl.html',
            controller: 'SupportCaseChangeItemGroupController as vm'
        }},
        resolve: {
            itemGroups: itemGroupResolver
        }
    });
}

// @ngInject
function itemGroupResolver(SupportApiService) {
    return SupportApiService.getItemGroupBriefs();
}

// @ngInject
function SupportCaseChangeItemGroupController($state, $scope, itemGroups, SupportApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.isEditing = false;
    vm.itemGroups = itemGroups.results;
    vm.selectedProduct = {};
    vm.selectedProductCopy = {};
    vm.selectedItemGroup = {};

    //Methods
    vm.recieveProduct = recieveProduct;
    vm.removeProduct = removeProduct;
    vm.isAllowedToSave = isAllowedToSave;
    vm.startEditing = startEditing;
    vm.saveChange = saveChange;
    vm.cancelEditing = cancelEditing;

    activate();

    function activate() {
    }

    function startEditing() {
        vm.isEditing = true;
        vm.selectedItemGroup = {};
        vm.selectedProduct.preferredSupplier = {};
        vm.selectedProduct.suppliers = [];
    }
    function saveChange() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmUpdateData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                var suppliers = _.map(vm.selectedProduct.suppliers, 'id');
                SupportApiService.changeItemGroup({ productId: vm.selectedProduct.id, itemGroupId: vm.selectedItemGroup.id, preferredSupplierId: vm.selectedProduct.preferredSupplier.id, supplierIds: suppliers }).then(function(response) {
                    cancelEditing();
                    ToasterService.showSuccess($translate.instant('support.itemGroupChanged'), $translate.instant('support.supportCase'));
                }, function(error) {
                    ToasterService.showError(error.message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    function cancelEditing() {
        vm.isEditing = false;
        removeProduct();
    }

    function recieveProduct(product) {
        vm.selectedProduct = product;
        loadSpinnerService.start("mainSpinner");
        SupportApiService.getProduct(vm.selectedProduct.id).then(function(response) {
            vm.selectedProduct = response;
            vm.selectedProductCopy = angular.copy(response);
        }, function(error) {
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }
    function removeProduct() {
        vm.selectedProduct = {};
        vm.selectedProductCopy = {};
        vm.selectedItemGroup = {};
        $scope.$broadcast('clearArticleEvent');
    }

    function isAllowedToSave() {
        return vm.selectedProduct && vm.selectedProduct.id > 0 &&
            vm.selectedItemGroup && vm.selectedItemGroup.id > 0 &&
            vm.selectedProduct.suppliers && vm.selectedProduct.suppliers.length > 0 &&
            vm.selectedProduct.preferredSupplier && vm.selectedProduct.preferredSupplier.id > 0;
    }
}

angular
    .module('supportcases.changeitemgroup', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseChangeItemGroupController', SupportCaseChangeItemGroupController);
